module.exports = __webpack_public_path__ + "img/mic.fa9b4308.svg";